<template>
  <div class="officialDocument">
    <div class="container">
      <div class="rowView pageFirstView">
        <div class="areaPageTitle">
          <h1 class="_kanji">公式文章一覧</h1>
        </div>
				<p>
規定書、報告書など公式文章を掲載します。
				</p>
			</div>

			<div v-show="checkHideContents(SecondLayer)">
				<div class="rowView _isNotDetail">
					<sort-panel @parentMethod="updateList" :origin=originList :page-range="10" :page-num=currentPage v-if="setListPanel"></sort-panel>
					<any-list :display-list="displayList" :any-list="5"></any-list>
				</div>
			</div>
    </div>

<!--		<router-view v-on:changeDetail="setDetail"></router-view>-->
  </div>
</template>

<script>
import sortPanel from '@/components/SortPanel.vue'
import anyList from '@/components/AnyList.vue'

export default {
  name: 'official',
  components:{
    sortPanel, 
		anyList,
  },
  data: function () {
    return {
      originList:[],
      displayList:[],
			orderList:[],
			currentPage:1,
/*
      detailIndex:0,
			detailName:'',
*/
			pageTitle:"公式文章一覧",
			description:"豊嶋精密工業株式会社規定書、報告書など公式文章を掲載します。",
			keywords:"規定書 報告書 公式文章",
			ogType:"article",
    }
  },
  computed: {
		setListPanel:function() {
/*直呼び出しの場合、jsonが揃ってから構築しないと、再構築してくれない。*/
			return this.originList.length > 0
		}
	},
  beforeCreate: function() {console.log("beforeCreate "+this.$options.name)
//console.dir(this.displayList) //< displayListが存在しない
	},
	created:function() {this._log("created "+this.$options.name)
//console.dir(this.displayList)  //< displayListは定義済みだが、中身はない
	},
  beforeMount:function() {this._log("beforeMount "+this.$options.name)
//ページ初期構築時の情報をセットする
		this.setList()
/*パラメータに?list=2の表記があった場合はその対象リストを表示するようにする*/
		if(this.$route.query.list) {
			this.currentPage = Number(this.$route.query.list)
		}
//console.dir(this.displayList)  //初期化済みで中身あり。 +sortPanel beforeMount
  },
  mounted: function() {this._log("mounted "+this.$options.name)

/*子が呼び出されているときは、以下をセットしないようにしないといけない*/
		if( !this.checkHierarchy()) {
			this.$store.commit('updatePageSectionInfo', this.gatherTagId())
			this.$store.commit('updatePageBackgroundStyle', 'appBackgroundBase')
	
/*head情報をセットする*/
			this.$store.commit('updateCurrentTitle', this.pageTitle)
			this.$store.commit('updateCurrentDescription', this.description)
			this.$store.commit('updateCurrentKeywords', this.keywords)
			this.$store.commit('updateCurrentOgUrl', this.isUrl)
			this.$store.commit('updateCurrentOgType', this.ogType)
			this.$store.commit('updateCurrentOgDesc', this.description)
			if(this.currentPage == 1) {
				this.$store.commit('updateLinkCanonical', 'https://toyoshimaseimitsu.co.jp/about/official?list=1')
			} else {
				this.$store.commit('updateLinkCanonical', '')
			}
			this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())
	
			this.changePageScrollAnchor()
		}
  },
  beforeUpdate:function() {this._log("beforeUpdate "+this.$options.name)

/*ブラウザー戻る進む処理変化の場合は、欠損するデータを補う*/
/*vue-routerで指定するやり方では動かず*/
		if(this.$route.params.anyList == undefined) {
			this.$route.params.anyList = 5 //セットできる プロパティもある状態でセット可能
		}
		if(this.$route.params.detail == undefined) {
			this.detailName = this.$route.params.pageId
			let aIndex =  this.displayList.findIndex(({title}) => title === this.detailName)
			this.detailIndex = aIndex
      let aImg = this.displayList[aIndex]
			this.$route.params.detail  = aImg
		}

		if(this.$route.query.list) {
/*ブラウザーリロード処理変化の場合は、urlに合わせたリスト表示を更新する必要がある*/
			let aPageNumber = Number(this.$route.query.list)
			if(aPageNumber != this.currentPage) {
				this.currentPage = aPageNumber
			}
		} else {
				this.currentPage = 1
		}
	},
  updated:function() {this._log("updated "+this.$options.name)

/*子が呼び出されているときは、以下をセットしないようにしないといけない*/
		if( !this.checkHierarchy()) {
			this.$store.commit('updatePageSectionInfo', this.gatherTagId())
			this.$store.commit('updatePageBackgroundStyle', 'appBackgroundBase')

/*head情報をセットする*/
			this.$store.commit('updateCurrentTitle', this.pageTitle)
			this.$store.commit('updateCurrentDescription', this.description)
			this.$store.commit('updateCurrentKeywords', this.keywords)
			this.$store.commit('updateCurrentOgUrl', this.isUrl)
			this.$store.commit('updateCurrentOgType', this.ogType)
			this.$store.commit('updateCurrentOgDesc', this.description)
			if(this.currentPage == 1) {
				this.$store.commit('updateLinkCanonical', 'https://toyoshimaseimitsu.co.jp/about/official?list=1')
			} else {
				this.$store.commit('updateLinkCanonical', '')
			}
			this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())
		}
  },
  methods:{
    setList() {
			if(this.$store.getters.originListOfficial.length == 0 ) {
				/*データがない場合は、storeの状態を監視して、読み込み終了とともにセットする*/
				this.detailName = decodeURI(this.$route.path.match(/([^\/.]+)/g).pop())
				if(this.detailName != 'pdf') {
/*詳細ページの場合は一度、リストページに戻す*/
					this.$router.push({path:"/about/official?list=1"})
				}else{
/*リストページの場合*/
					this.detailName = ''
				}
				this.$store.watch(
					(state, getters) => getters.originListOfficial,
					(newValue, oldValue) => {
this._log("LOADED")
						this.originList = this.$store.getters.originListOfficial
						this.resetList()
/*詳細ページの場合は以下が必要*/
						if(this.detailName != '') {
							this.rePushDetail()
						}
					}
				)
			} else {
				this.originList = this.$store.getters.originListOfficial
				this.resetList()
			}
    },
    resetList() {
			this.displayList = Object.assign([], this.originList)
			this.orderList = Object.assign([], this.originList)
    },
    updateList(aDisplayList, aDisplayListAll, aPageNumber) {
//子から呼び出す表示更新メソッド
      this.displayList = aDisplayList
			this.orderList = aDisplayListAll
			if(aPageNumber != this.currentPage) {
				this.currentPage = aPageNumber
				this.$router.push({
					name: '公式文章一覧',
					query: { 
							list:this.currentPage,
					}
				})
			}
    },
  },
}
</script>


<style>
</style>
